module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }, [_c('div', {
    staticClass: "row ls-display-flex align-items-center justify-content-end pr-15"
  }, [(_vm.invoices.length) ? _c('div', [_c('a', {
    staticClass: "ls-btn-primary ls-no-margin ls-xs-margin-bottom ls-xs-margin-left",
    on: {
      "click": _vm.downloadCsv
    }
  }, [_vm._v(_vm._s(_vm.$t('contracts.main.export_csv')))])]) : _vm._e()])]), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('filter-invoices'), _vm._v(" "), (_vm.invoices) ? _c('div', [_c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('div', [(_vm.invoices.length) ? _c('table', {
    staticClass: "ls-table ls-sm-space ls-table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('invoices.attributes.id')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('invoices.attributes.customer')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('invoices.attributes.amount_due')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.created_at')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.due_date')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.paid_at')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('service_taxes.messages.nf')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.status')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(invoice, index) {
    return _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('invoices.attributes.id_alias')) + ":")]), _vm._v(" " + _vm._s(invoice.identifier) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('invoices.attributes.contract_id')) + ":")]), _vm._v(" "), (invoice.contract_id) ? _c('router-link', {
      attrs: {
        "title": "",
        "to": {
          name: 'contract_details',
          params: {
            id: invoice.contract_id
          }
        }
      },
      slot: "button"
    }, [_vm._v(_vm._s(invoice.contract_id))]) : _c('div', [_vm._v("\n                " + _vm._s(_vm.$t('invoices.attributes.contract_id_not_assigned')) + "\n              ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(invoice.customer.name))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm.money.parseViewValue(invoice.amount_due)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.date.parseDate(invoice.created_at)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.date.parseDate(invoice.due_date)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.paymentDate(invoice)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(invoice.service_tax_invoice) ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('service_taxes.attributes.authenticity_code')) + ":")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.openTaxInvoice(invoice.service_tax_invoice)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(invoice.service_tax_invoice.nf_id) + "\n                ")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('service_taxes.attributes.created_at')) + ":")]), _vm._v(" " + _vm._s(_vm.date.parseDate(invoice.service_tax_invoice.created_at)) + "\n\n                "), _c('span', {
      class: _vm.$t('service_taxes.tags.' + invoice.service_tax_invoice.status)
    }, [_vm._v("\n                  " + _vm._s(_vm.$t('service_taxes.attributes.statuses.' + invoice.service_tax_invoice.status)) + "\n                ")])]) : _c('div', [_vm._v("\n                " + _vm._s(_vm.$t('service_taxes.messages.not_generated')) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.$t('invoices.attributes.statuses.' + invoice.status)))]), _vm._v(" "), _c('td', [_c('authorized-link', {
      attrs: {
        "tag": "show_invoice"
      }
    }, [_c('router-link', {
      staticClass: "ls-btn ls-no-margin",
      attrs: {
        "to": {
          name: 'invoice_details',
          params: {
            invoice_id: invoice.id
          }
        },
        "title": _vm.$t('application.menu.general_settings')
      }
    }, [_vm._v("Detalhes")])], 1)], 1)])
  }))]) : _c('div', {
    attrs: {
      "role": "alert"
    }
  }, [_c('empty-list')], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "updater": _vm.getInvoices
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13f038e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/invoices/List.vue
// module id = 729
// module chunks = 1